import { Instance } from 'mobx-state-tree';
import { SsoProviderDtoModelBase } from './SsoProviderDtoModel.base';

/* The TypeScript type of an instance of SsoProviderDtoModel */
export interface SsoProviderDtoModelType extends Instance<typeof SsoProviderDtoModel.Type> {}

/* A graphql query fragment builders for SsoProviderDtoModel */
export { selectFromSsoProviderDto, ssoProviderDtoModelPrimitives, SsoProviderDtoModelSelector } from './SsoProviderDtoModel.base';

/**
 * SsoProviderDtoModel
 */
export const SsoProviderDtoModel = SsoProviderDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
